import * as React from "react";

import ArrowIcon from "../../assets/arrow-top-right.inline.svg";
import {
  IconWrapper,
  PersonDetails,
  PersonImage,
  PersonRole,
  PersonTitle,
  PersonWrapper,
} from "./Person.styles";

type Props = {
  details: Queries.SanityPeople;
};

export const PersonSummary: React.FC<Props> = ({ details }: Props) => {
  const { name, profileImage, profileUrl, role } = details;

  const profileImageSrc =
    profileImage?.asset?.gatsbyImageData.images.fallback?.src;

  return (
    <PersonWrapper to={`/who-we-are/${profileUrl}`}>
      {profileImageSrc && <PersonImage $image={profileImageSrc} />}
      <PersonDetails className="px-4 py-2 lg:pb-3 lg:pl-5 lg:pr-8 lg:pt-3">
        <IconWrapper>
          <ArrowIcon width="20" height="20" />
        </IconWrapper>
        <div>
          <PersonTitle>{name}</PersonTitle>
          <PersonRole>{role}</PersonRole>
        </div>
      </PersonDetails>
    </PersonWrapper>
  );
};
